import { AuthEnums } from "models/enums";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyService } from "services";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

function useEmployeeActions() {
  const location = useLocation();
  const navigate = useNavigate();

  const addEmployee = async () => {
    navigate(UrlHelper.formatPath(`/Employee/Create`), {
      state: { background: location },
    });
  };

  const userSettings = async () => {
    navigate(UrlHelper.formatPath(`/Settings?section=employees`), {
      state: { background: location },
    });
  };

  const addEmployeeMoreAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AddUser),
    icon: IconDefinitionConstants.WUser,
    onClickHandler: addEmployee,
    hidden: !CompanyService.hasRelations([AuthEnums.PersonCompanyRelationType.Admin]),
  };

  const employeeSettingsMoreAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.User),
    icon: IconDefinitionConstants.WSettings,
    onClickHandler: userSettings,
    hidden: !CompanyService.hasRelations([AuthEnums.PersonCompanyRelationType.SalaryAdmin]),
  };

  return { employeeSettingsMoreAction, addEmployeeMoreAction };
}

export default useEmployeeActions;
